<div [formGroup]="formArray.controls[group]" id="audience-targeting" class="audience-targeting">
    <targeting-container label="AUDIENCE" (onEdit)="openSidebar()" [hideRemove]="true" [disabled]="isDisabled">
        <div class="hide-chip-close-button" [class.disabled]="isDisabled">
            <div class="row no-gutters">
                <div class="margin-top-right-5">
                    <span class="font-weight-bold mr-2">Gender:</span>
                    <span class="chip-container">
                        <acl-ngx-chip [text]="genderControl.value" (click)="openSidebar()">
                        </acl-ngx-chip>
                    </span>
                </div>
                <div class="margin-5">
                    <span class="font-weight-bold mr-2">Age:</span>
                    <span class="chip-container">
                        <acl-ngx-chip [text]="ageSelectionLabel" (click)="openSidebar()">
                        </acl-ngx-chip>
                    </span>
                </div>
                <div class="margin-5" *ngIf="onTargetGoalControl.value">
                    <span class="font-weight-bold mr-2">On Target:</span>
                    <span class="chip-container">
                        <acl-ngx-chip text="{{onTargetGoalControl.value}}%" (click)="openSidebar()">
                        </acl-ngx-chip>
                    </span>
                </div>
                <div class="margin-5" *ngIf="!includeSelectionText && !excludeSelectionText && !segmentSetLabel">
                    <span class="font-weight-bold mr-2 chip-container">No Audience Segment</span>
                </div>
                <div class="margin-5" *ngIf="includeSelectionText || excludeSelectionText">
                    <span class="font-weight-bold mr-2">{{SegmentTargetType[segmentType].label}}:</span>
                    <span class="chip-container font-weight-normal hide-chip-close-button" *ngIf="includeSelectionText">
                        <acl-ngx-tooltip [trigger]="includeTrigger" [disabled]="!tooltipTextForInclude.length"
                            [text]="tooltipTextForInclude.join(', ')">
                        </acl-ngx-tooltip>
                        <ng-template #includeTrigger>
                            <acl-ngx-chip (click)="openSidebar()" [text]="includeSelectionText">
                            </acl-ngx-chip>
                        </ng-template>
                    </span>
                    <span class="chip-container font-weight-normal exclude hide-chip-close-button"
                        *ngIf="excludeSelectionText">
                        <acl-ngx-tooltip [trigger]="excludeTrigger" [disabled]="!tooltipTextForExclude.length"
                            [text]="tooltipTextForExclude.join(', ')">
                        </acl-ngx-tooltip>
                        <ng-template #excludeTrigger>
                            <acl-ngx-chip (click)=" openSidebar()" [text]="excludeSelectionText">
                            </acl-ngx-chip>
                        </ng-template>
                    </span>
                </div>
                <div class="margin-5" *ngIf="segmentSetLabel && segmentType">
                    <span class="font-weight-bold mr-2">{{SegmentTargetType[segmentType].label}}:</span>
                    <span class="chip-container">
                        <acl-ngx-chip (click)="openSidebar()" [text]="segmentSetLabel">
                        </acl-ngx-chip>
                    </span>
                </div>
            </div>
        </div>
    </targeting-container>

    <!-- nielsen demo template -->
    <ng-template #nielsenDemo>
        <div [formGroup]="nielsenDemoControl" class="nielsen-demo">
            <div class="row padding-left-30 margin-bottom-20 border-bottom">
                <!--GENDER-->
                <div class="col">
                    <div class="row title">
                        <strong>GENDER</strong>
                    </div>
                    <div class="row margin-left-5 margin-tb-15">
                        <ng-container *ngFor="let gender of genderKeys">
                            <div class="margin-right-15">
                                <acl-ngx-radio formControlName="gender" [value]="gender"
                                    [checked]="genderControl.value === gender">
                                    {{gender}}
                                </acl-ngx-radio>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="row padding-left-30 margin-bottom-20 border-bottom">
                <!--AGE-->
                <div class="col-10">
                    <div class="row title">
                        <strong>AGE</strong>
                    </div>
                    <div class="margin-tb-15 padding-bottom-30">
                        <range-slider *ngIf="open" hide-tooltip [min]="rangeSliderConfig.min"
                            [max]="rangeSliderConfig.max" [minSelected]="ageMinControl.value"
                            [maxSelected]="ageMaxControl.value" [step]="rangeSliderConfig.step" [hide-tooltip]="true"
                            [showStepIndicator]="true" [stepIndicatorLabel]="rangeSliderConfig.stepLabel"
                            (onChange)="onSliderChange($event)" [sliderWidth]="500">
                        </range-slider>
                    </div>
                </div>
            </div>
            <div class="row padding-left-30 margin-bottom-20 border-bottom">
                <!--ON TARGET GOAL-->
                <div class="col-3">
                    <div class="row title">
                        <strong>ON TARGET GOAL</strong>
                    </div>
                    <div class="margin-tb-15">
                        <acl-ngx-input contentClass="planner-input" formControlName="onTargetGoal" type="number"
                            accept="number" min="1" max="100">
                        </acl-ngx-input>
                        <span class="on-target-icon">%</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <!-- audience segment template -->
    <ng-template #audienceSegment>
        <div class="segment-selector container-fluid">
            <div class="segment-select-wrapper">
                <strong>TARGET BY</strong>
                <div class="d-inline-block margin-left-15 margin-bottom-25">
                    <acl-ngx-select placeholder="Select" [initialValue]="{'value': segmentType}"
                        (change)="changeSegmentType($event)" menuWidth="220px">
                        <acl-ngx-option *ngFor="let type of SegmentTargetType | keyvalue" [label]="type.value.label"
                            [value]="type.value.key">
                        </acl-ngx-option>
                    </acl-ngx-select>
                </div>
            </div>

            <!--CUSTOM or TVA or TVA DETERMINISTIC SEGMENTS-->
            <ng-container *ngIf="segmentType === SegmentTargetType.Custom.key
            || segmentType === SegmentTargetType.TVA.key || segmentType === SegmentTargetType.TVADeterministic.key">
                <div class="segments">
                    <browse-include-exclude [(dataConfig)]="audienceDataConfig" [settings]="audienceSettings"
                        [hidden]="!open">
                    </browse-include-exclude>
                </div>
            </ng-container>

            <!--SEGMENT SETS-->
            <ng-container *ngIf="segmentType === SegmentTargetType.SegmentSet.key">
                <strong>SEGMENT SET NAME</strong>
                <div class="margin-top-15">
                    <multi-select-auto-complete [placeholder]="'Select Segment Set'" [settings]="segmentSetSettings"
                        [(selectedData)]="selectedSegmentSet" (onSelect)="onSegmentSetSelect($event)"
                        [disabled]="isDisabled">
                    </multi-select-auto-complete>
                </div>
            </ng-container>
        </div>
    </ng-template>

    <acl-ngx-flyout [open]="open" (close)="cancel()" large="true" portalRoot="audience-targeting">
        <acl-ngx-flyout-header title="Audience Segments" (close)="cancel()">
        </acl-ngx-flyout-header>
        <acl-ngx-flyout-body>
            <div>
                <ng-container [ngTemplateOutlet]="nielsenDemo"></ng-container>
                <ng-container [ngTemplateOutlet]="audienceSegment"></ng-container>
            </div>
        </acl-ngx-flyout-body>
        <acl-ngx-flyout-footer [leftButton]="saveButton" [rightButton]="cancelButton"></acl-ngx-flyout-footer>
    </acl-ngx-flyout>
</div>
